import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

function useSetSearchParams() {
  const searchParams = useSearchParams();

  const setSearchParams = useCallback((name: string, value: string) => {
    const url = new URL(window.location.toString());
    url.searchParams.set(name, value);
    window.history.replaceState(window.history.state, '', url);
  }, []);

  const createQueryParams = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams);
      params.set(name, value);

      return params.toString();
    },
    [searchParams]
  );

  const retainQueryParams = (link: string) => {
    const url = new URL(window.location.toString());
    return `${link}${url.search}`;
  };

  const removeQueryParams = useCallback((name: string) => {
    const url = new URL(window.location.toString());
    url.searchParams.delete(name);
    window.history.replaceState(window.history.state, '', url);
  }, []);

  return { searchParams, setSearchParams, createQueryParams, retainQueryParams, removeQueryParams };
}

export default useSetSearchParams;
